import combine from "../services/combine-service";
import WodRemaining from "../services/wodremaining";
const wods = {
  derivitives: [],
  assignedwo: [],
  fixedwods: []
};
export default function(state = wods, action) {
  switch (action.type) {
    case "RealTimeUpdate for workorders":
      if (state.derivitives.length === 0) {
        action.payload = action.payload.map(wod => {
          return { ...wod, remaining: WodRemaining(wod) };
        });
        let fixedWods = action.payload.filter(wod => wod.fixedPrice > 0);
        // console.log(fixedWods);
        return {
          ...state,
          derivitives: action.payload,
          fixedwods: fixedWods
        };
      } else {
        let newderivitives = state.derivitives;
        // console.log(action.payload);
        let wods = action.payload;
        let fixedWods = action.payload.filter(wod => wod.fixedPrice > 0);
        for (let wod of wods) {
          let windex = newderivitives.findIndex(
            nd => nd.workOrderNbr === wod.workOrderNbr
          );
          newderivitives[windex] = wod;
        }

        return {
          ...state,
          derivitives: newderivitives,
          fixedwods: newderivitives.filter(wod => wod.fixedPrice > 0)
        };
      }
      break;
    case "Feathers Update > workorders":
      let derivitives = combine(
        state.derivitives,
        action.payload,
        "workOrderNbr",
        action.deletestatus
      );
      return {
        ...state,
        derivitives,
        fixedwods: derivitives.filter(wod => wod.fixedPrice > 0)
      };
      break;

    default:
  }

  return state;
}



// WEBPACK FOOTER //
// ./src/reducers/wod-reducer.js